module.exports = __webpack_public_path__ + "38d3755e5e3ef857c3fe12c70895cb52.MP3";